export default __webpack_public_path__ + "static/media/Activities.24cb3436.svg";